export default "__VITE_PUBLIC_ASSET__beaabc06__"